// ProductPage.js
import React from "react";
import { Helmet } from "react-helmet";
import { useParams, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa"; // 🡐 Icono de flecha

const ProductPage = ({ productos, addToCart, stripePromise }) => {
  const { nombre } = useParams();
  const navigate = useNavigate();
  const producto = productos.find((p) => p.nombre === nombre);
  const pageTitle = `${producto.nombre} | Esencial Beauty`;
const pageDescription = producto.descripcion;
const pageImage = `https://esencial-eight.vercel.app${producto.imagen}`;
const pageUrl = `https://esencial-eight.vercel.app/producto/${producto.nombre}`;


  if (!producto) return <div>Producto no encontrado</div>;

  const handleBuyNow = async (producto) => {
    try {
      const res = await fetch("https://esencial.onrender.com/create-checkout-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ ...producto, quantity: 1 }],
        }),
      });
      const data = await res.json();
      if (!data?.id) return alert("Error al crear sesión de pago");

      const stripe = await stripePromise;
      await stripe.redirectToCheckout({ sessionId: data.id });
    } catch (err) {
      console.error(err);
      alert("Error de conexión con Stripe");
    }
  };

  return (
  <div
    style={{
      padding: "40px 20px",
      maxWidth: "900px",
      margin: "0 auto",
      fontFamily: "Arial, sans-serif",
      lineHeight: "1.6",
    }}
  >
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />

      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="product" />

      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>

      {/* 🔙 Botón para volver al inicio */}
      <button
        onClick={() => navigate("/")}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          background: "none",
          border: "none",
          color: "#4B6CB7",
          cursor: "pointer",
          fontSize: "16px",
          marginBottom: "20px",
        }}
      >
        <FaArrowLeft /> Volver al inicio
      </button>

      {/* Título */}
      <h1
        style={{
          fontSize: "36px",
          marginBottom: "20px",
          textAlign: "center",
          color: "#222",
        }}
      >
        {producto.nombre}
      </h1>

      {/* Imagen centrada */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "30px",
        }}
      >
        <img
          src={producto.imagen}
          alt={producto.nombre}
          style={{
            width: "80%",
            maxWidth: "500px",
            height: "auto",
            borderRadius: "16px",
            objectFit: "cover",
            boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
          }}
        />
      </div>

      {/* Descripción */}
      <section style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "22px", color: "#333", marginBottom: "10px" }}>
          Descripción
        </h2>
        <p style={{ fontSize: "17px", color: "#444" }}>{producto.descripcion}</p>
      </section>

      {/* Modo de uso dinámico */}
      {producto.modoUso && (
        <section style={{ marginBottom: "30px" }}>
          <h2 style={{ fontSize: "22px", color: "#333", marginBottom: "10px" }}>
            Modo de uso
          </h2>
          <ul style={{ textAlign: "left", color: "#555", fontSize: "16px" }}>
            {producto.modoUso.map((paso, index) => (
              <li key={index}>👉 {paso}</li>
            ))}
          </ul>
        </section>
      )}

      {/* Beneficios dinámicos */}
      {producto.beneficios && (
        <section style={{ marginBottom: "30px" }}>
          <h2 style={{ fontSize: "22px", color: "#333", marginBottom: "10px" }}>
            Beneficios
          </h2>
          <ul style={{ textAlign: "left", color: "#555", fontSize: "16px" }}>
            {producto.beneficios.map((beneficio, index) => (
              <li key={index}>✨ {beneficio}</li>
            ))}
          </ul>
        </section>
      )}

      {/* Precio */}
      <p
        style={{
          fontWeight: "700",
          fontSize: "22px",
          marginBottom: "30px",
          textAlign: "center",
          color: "#222",
        }}
      >
        Precio: {(producto.precio / 100).toFixed(2)} €
      </p>

      {/* Botones */}
      <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
        <button
          onClick={() => addToCart(producto)}
          style={{
            padding: "12px 24px",
            background: "#4B6CB7",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          Añadir al carrito
        </button>

        <button
          onClick={() => handleBuyNow(producto)}
          style={{
            padding: "12px 24px",
            background: "#25D366",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          Comprar ahora
        </button>
      </div>
    </div>
  );
};

export default ProductPage;
